import { useEffect, useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import { useSelector } from "react-redux";
import moment from "moment";
import CoursesTable from "./CoursesTable";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const courseList = useSelector((state) => state?.courseDetail);

  useEffect(() => {
    if (Array.isArray(courseList?.data)) {
      const filteredData = courseList.data.map((row) => ({
        id: row?._id,
        courseTitle: row?.name,
        dueDate: row?.created?.on && row?.dueDateinDays != null
          ? moment(row.created.on).add(row.dueDateinDays, 'days').format("DD-MM-YYYY")
          : "",
        noOfTenants: row?.assignedToTenants?.length,
      }));
      setCourses(filteredData);
    }
  }, [courseList.data]);


  return (

    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <CoursesTable rows={courses} />
    </Box>
  );
};

export default Courses;
